/* eslint-disable import/prefer-default-export */
import { css } from "@emotion/react";

export const gap8Css = css`
  gap: 8px;
`;
